export const redirectCookieName = 'cokeServiceHomeSkip';

export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 12;
